import React, { useEffect, useState } from 'react'
import Summary from '../components/Summary/Summary'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { fetchLabels } from '../utils/Label'
import { fetchData, saveLogEvent } from '../utils/Utils'
import { voiceStore } from '../stores/voiceStore'
import { observer } from 'mobx-react-lite'

const HomePage = () => {

  const [labels, setLabels] = useState('')
  const [customerInfo, setCustomerInfo] = useState(null);

  useEffect(() => {
    fetchData()
      .then(data => {
        const CommunicationLanguage = sessionStorage.getItem("CommunicationLanguage")
        if (!CommunicationLanguage) {
          sessionStorage.setItem("CommunicationLanguage", JSON.stringify(data?.data?.CustomerDetails.CommunicationLanguage))
          voiceStore.setLanguage(data?.data?.CustomerDetails.CommunicationLanguage)
        }
        setCustomerInfo(data.data);
        voiceStore.setVoiceCommand(data?.data?.GroupDetails?.Customers[0]?.NextInstalmentDetails?.VoiceCommand1)
        saveLogEvent(
          {
            logLevel: "info",
            statusCode: 200,
            status: "success",
            source: "MCRO",
            message: { trigger: "On Load Of Home Page", Page: "Home Page", branch: data?.data?.CustomerDetails?.Branch?.Name },

          },

        );
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }, []);

  useEffect(() => {
    const fetchLabelsData = async () => {
      const updatedLabels = await fetchLabels();
      setLabels(updatedLabels)
    };

    fetchLabelsData();
  }, [sessionStorage.getItem("CommunicationLanguage"), voiceStore.language]);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <Header breadcrumbs="Customer App" labels={labels} customerInfo={customerInfo} />
        <div className=" mx-4 mb-16 font-gotham-rounded">
          <Summary labels={labels} customerInfo={customerInfo} />
        </div>
        <Footer className="fixed bottom-0 w-full bg-white" labels={labels} customerInfo={customerInfo} />
      </div>
    </>
  )
}

export default observer(HomePage)